import { makeAutoObservable, reaction } from "mobx";
import { RootStore } from "./RootStore";
import { SetStateAction } from "react";
import { CourtBookingApi } from "../apis/bookingapi";
import { ACCESS_TOKEN } from "../utils/constants";
import { Strings } from "../utils/strings";

export class OTPStore {
  rootStore: RootStore;
  otp?: string;
  isLoading: boolean = false;
  isOTPVerified: boolean = false;
  modalData?: {
    visible: boolean;
    title: string;
    children: React.ReactNode | string;
    btnText?: string;
    btnVariant?: string;
    onClose: () => void;
    onAccept?: () => void;
    headerIcon?: React.ReactNode;
  };
  isSuccess: boolean = false;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false });
    reaction(
      () => ({
        codeLength: this.otp?.length,
      }),
      (current) => {
        if (current.codeLength === 4) {
          this.verifyOTPCode();
        }
      }
    );
  }

  reset = () => {
    this.isOTPVerified = false;
    this.otp = undefined;
    this.isSuccess = false;
    this.isLoading = false;
    this.modalData = undefined;
  };

  setOTP = (otp?: string) => {
    this.otp = otp;
  };

  handleOTPChange = (event: {
    target: { value: SetStateAction<string | undefined> };
  }) => {
    let value = event.target?.value?.toString();
    this.setOTP(value);
    if (this.isSuccess) {
      this.isSuccess = false;
    }
  };

  verifyOTPCode = async () => {
    if (this.otp?.length === 4) {
      try {
        this.isLoading = true;
        const response = await CourtBookingApi.otpCodeVerify({
          email: this.rootStore.loginStore.email ?? "",
          otp: this.otp,
        });
        localStorage.setItem(ACCESS_TOKEN, response.jwt ?? "");
        this.isLoading = false;
        this.isSuccess = true;
        this.isOTPVerified = true;
      } catch (error: any) {
        this.isLoading = false;
        this.modalData = {
          visible: true,
          title: Strings.ERROR_OTP_VERIFICATION,
          children:
            error.message ??
            "Some error occurred while verifying OTP. Please try again.",
          btnText: Strings.OK,
          btnVariant: "outline-danger",
          onClose: () => (this.modalData = undefined),
        };
      }
    } else {
      this.modalData = {
        visible: true,
        title: Strings.INVALID,
        children: Strings.ENTER_VALID_OTP,
        btnText: Strings.OK,
        btnVariant: "outline-danger",
        onClose: () => (this.modalData = undefined),
      };
    }
  };

  handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior (form submission)
      this.verifyOTPCode(); // Call sendOTPCode when Enter key is pressed
    }
  };
}
